<div class="sticky top-24 z-10">
  <form class="flex flex-col gap-4 shadow-md bg-white p-5 rounded-lg">
    <div class="flex flex-col items-center">
      <h2 class="text-lg font-bold w-full text-center" i18n>Filters</h2>
      <app-divider></app-divider>
    </div>
    <app-course-catalogue-location-filter></app-course-catalogue-location-filter>
    <app-course-catalogue-period-filter></app-course-catalogue-period-filter>
    <app-course-catalogue-age-filter></app-course-catalogue-age-filter>
    <app-course-catalogue-theme-category-filter></app-course-catalogue-theme-category-filter>
    <app-course-catalogue-theme-filter></app-course-catalogue-theme-filter>
    <button
      class="mt-4 text-accent hover:text-accent-800 cursor-pointer text-center"
      (click)="reset()"
      type="button"
      i18n
    >
      Reset Filter
    </button>
  </form>
  <img
    class="hidden lg:inline mt-8 max-h-72"
    src="https://skillz.blob.core.windows.net/images/prismarine/hero_female_camps.png"
    alt="Female hero skillz"
    i18n-alt
  />
</div>
